function SearchItem({ img, ...rest }) {
  return <img src={img.urls.thumb} alt={img.id} {...rest} />;
}

export default SearchItem;
